import { Helmet } from "react-helmet-async";

const SITE_NAME_AR = "الرملاء للصناعات الخشبية";
const SITE_URL = "https://www.alramlaa.com";
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;

export default function Seo({
  title,
  description,
  path = "",
  image,
  type = "website",
  price,
  currency = "SAR",
  availability,
  noindex = false,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME_AR}` : SITE_NAME_AR;
  const url = `${SITE_URL}${path}`;
  // Social crawlers (Facebook/WhatsApp/Twitter) fetch og:image with no page
  // context to resolve a relative path against, unlike a browser — callers
  // may pass a same-origin relative URL (e.g. a static /photos/... asset), so
  // always make it absolute here.
  const rawImage = image || DEFAULT_IMAGE;
  const ogImage = rawImage.startsWith("http") ? rawImage : `${SITE_URL}${rawImage.startsWith("/") ? "" : "/"}${rawImage}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={url} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME_AR} />
      <meta property="og:title" content={fullTitle} />
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="ar_SA" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={ogImage} />

      {type === "product" && price != null ? (
        <>
          <meta property="product:price:amount" content={String(price)} />
          <meta property="product:price:currency" content={currency} />
          {availability ? <meta property="product:availability" content={availability} /> : null}
        </>
      ) : null}
    </Helmet>
  );
}
